import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './formError.component.html',
  styleUrls: ['./formError.component.less']
})
export class FormErrorComponent {

  messages = {
    'required': () => 'The ' + this.fieldName + ' field is required.',
    'minlength': (params) => 'The min number of characters is ' + params.requiredLength,
    'maxlength': (params) => 'The max allowed number of characters is ' + params.requiredLength,
    'pattern': (params) => 'The required pattern is: ' + params.requiredPattern,
    'age': (params) => params.message
  };

  @Input() private control: AbstractControlDirective | AbstractControl;
  @Input() private fieldName: string;

  showErrors(): boolean {
    return this.control && this.control.errors && (this.control.dirty || this.control.touched);
  }

  errors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    return this.messages[type](params);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/formError/formError.component.ts